import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "@/lib/firebaseConfig";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Dois envios passam por aqui: a imagem de categoria (lib/upload.ts) e o ZIP
// da importação de dados (lib/dataTransfer.ts). São as únicas escritas do
// painel que não são callable: arquivo não atravessa uma Cloud Function com
// folga, e as regras do Storage exigem o claim `admin` nos dois caminhos.
export const storage = getStorage(app);

// A região é explícita porque as callables do zepadoca-functions vivem em
// us-central1. Sem informá-la, o SDK chama a região padrão e a função responde
// "not-found", que é um erro difícil de ligar à causa.
export const functions = getFunctions(app, import.meta.env.VITE_FUNCTIONS_REGION || "us-central1");

/** Ambiente do build, exibido na barra lateral quando não é produção. */
export const appEnv = import.meta.env.VITE_APP_ENV || "production";
export const isProduction = appEnv === "production";
export const projectId = firebaseConfig.projectId as string;
